<template>
  <div style="height:100%;">
    <el-row style="height:55px;">
      <el-form inline>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" icon="el-icon-plus" @click="addKeyword"></el-button>
            <el-button type="primary" icon="el-icon-delete" @click="deleteKeyword"></el-button>
          </el-button-group>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="输入要查询的关键字" v-model="keywords" style="margin-left:150px;">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row style="height:calc(100% - 55px - 42px);">
      <el-table :data="data" border style="width: 100%" height="100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="35">
        </el-table-column>
        <el-table-column prop="code" label="编码">
        </el-table-column>
        <el-table-column prop="name" label="关键词">
        </el-table-column>
        <el-table-column prop="english" label="英文">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.$index)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row style="height:42px;padding-top:10px;">
      <Pagination ref="srPagination" totalCountOrURL="/radio/s_keywords" :params="this.keywords?{keywords: this.keywords.trim()}:{}"
        @change="handlePageChange"></Pagination>
    </el-row>

    <el-dialog :visible.sync="showEdit" width="520px" :title="dialogTitle">
      <el-form label-width="60px" label-position="left">
        <el-form-item label="编码">
          <el-input v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="英文">
          <el-input v-model="form.english"></el-input>
        </el-form-item>
        <el-form-item style="padding-left:250px;margin-bottom:0;">
          <el-button @click="showEdit = false">取 消</el-button>
          <el-button type="primary" @click="save">保 存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from "@/components/PageNations/Pagination";
  export default {
    components: {
      Pagination
    },
    mounted() {
      this.getData();
    },
    data() {
      return {
        data: [],
        keywords: null,
        page: 1,
        size: 10,
        selectd: [],
        form: {},
        showEdit: false,
        dialogTitle: "",
        isEditNew: false
      };
    },
    methods: {
      handlePageChange(params) {
        this.page = params.page;
        this.size = params.size;
        this.getData();
      },
      getData() {
        let params = {
          page: this.page,
          size: this.size
        };
        if (this.keywords) {
          params.keywords = this.keywords.trim();
        }
        this.$getJSON("/radio/s_keywords", params).then(res => {
          this.data = res.data;
        });
      },
      handleSelectionChange(a) {
        this.selectd = a;
      },
      addKeyword() {
        this.isEditNew = true;
        this.form = {
          code: "",
          name: "",
          english: ""
        };
        this.showEdit = true;
        this.dialogTitle = "添加关键词";
      },
      deleteKeyword() {
        if (this.selectd.length == 0) {
          this.$message("未选择任何关键词");
          return;
        }
        this.$confirm(`确认删除${this.selectd.length}条关键词?`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            let ids = [];
            this.selectd.map(item => ids.push(item.id));
            this.$getJSON("/radio/d_keywords", {
              ids: ids
            }).then(res => {
              this.$message.success("删除成功");
              this.getData();
            });
          })
          .catch(() => {});
      },
      edit(idx) {
        this.isEditNew = false;
        this.form = JSON.parse(JSON.stringify(this.data[idx]));
        this.showEdit = true;
        this.dialogTitle = "编辑关键词";
      },
      save() {
        if (!this.form.name || (this.form.name = this.form.name.trim()) === "") {
          this.$message("关键词不能为空");
          return;
        }
        if (this.isEditNew) {
          this.$confirm("确认添加关键词?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(() => {
              this.showEdit = false;
              this.$getJSON("/radio/i_keywords", this.form).then(res => {
                this.$message.success("添加成功");
                this.page = 1;
                this.getData();
              });
            })
            .catch(() => {});
        } else {
          this.$confirm("确认修改关键词?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(() => {
              this.showEdit = false;
              this.$getJSON("/radio/u_keywords", this.form).then(res => {
                this.showEdit = false;
                this.$message.success("修改成功");
                this.page = 1;
                this.getData();
              });
            })
            .catch(() => {});
        }
      },
      search() {
        this.getData();
      }
    }
  };

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Keywords.vue